/**
 * controls if we want to debug in console or not
 * 
 * set it to true while not in production mode
 */
export const DEBUG = true;
